(function () {
  function initialiseCustomiser(customiser) {
    if (!customiser || customiser.dataset.initialised === 'true') return;

    customiser.dataset.initialised = 'true';

  const trigger = customiser.querySelector('[data-customiser-toggle]');
  const panel = customiser.querySelector('[data-customiser-panel]');
  const sideTypes = customiser.querySelectorAll('[data-side-type]');
  const total = customiser.querySelector('[data-embroidery-total]');
  const embroideryTextLimit = 16;
  const isLeftOnlyProduct = customiser.dataset.leftOnly === 'true';

const hospitals = {
  nsw: [
    {
      name: 'NSW Health',
      logo: 'https://cdn.shopify.com/s/files/1/0390/6463/3388/files/nsw-government-health-pathology-logo-png_seeklogo-446738.png?v=1781957956'
    }
  ],
  qld: [
    {
      name: 'QLD Health',
      logo: 'https://cdn.shopify.com/s/files/1/0390/6463/3388/files/Queensland-Government_logo.webp?v=1781957955'
    }
  ]
};

  const properties = {
    enabled: customiser.querySelector('[data-property="enabled"]'),
    leftType: customiser.querySelector('[data-property="left_type"]'),
    leftLogoSource: customiser.querySelector('[data-property="left_logo_source"]'),
    leftHospitalState: customiser.querySelector('[data-property="left_hospital_state"]'),
    leftHospital: customiser.querySelector('[data-property="left_hospital"]'),
    rightType: customiser.querySelector('[data-property="right_type"]'),
    rightLogoSource: customiser.querySelector('[data-property="right_logo_source"]'),
    rightHospitalState: customiser.querySelector('[data-property="right_hospital_state"]'),
    rightHospital: customiser.querySelector('[data-property="right_hospital"]'),
    sides: customiser.querySelector('[data-property="embroidery_sides"]'),
    total: customiser.querySelector('[data-property="embroidery_total"]'),
    leftUploadedLogo: customiser.querySelector('[data-property="left_uploaded_logo"]'),
    rightUploadedLogo: customiser.querySelector('[data-property="right_uploaded_logo"]'),
    leftFont: customiser.querySelector('[data-property="left_font"]'),
    rightFont: customiser.querySelector('[data-property="right_font"]'),
    leftTextColour: customiser.querySelector('[data-property="left_text_colour"]'),
    rightTextColour: customiser.querySelector('[data-property="right_text_colour"]'),
    leftReturningLogo: customiser.querySelector('[data-property="left_returning_logo"]'),
    rightReturningLogo: customiser.querySelector('[data-property="right_returning_logo"]'),
  };

function enforceLeftOnlyProduct() {
  if (!isLeftOnlyProduct) return;

  const rightChestBlock = customiser.querySelector('[data-right-chest-block]');
  const rightSideSelect = customiser.querySelector('[data-side-type="right"]');

  if (rightSideSelect) {
    rightSideSelect.value = '';
    rightSideSelect.disabled = true;
  }

  if (rightChestBlock) {
    rightChestBlock.hidden = true;
  }

  setProperty(properties.rightType, '');
  setProperty(properties.rightLogoSource, '');
  setProperty(properties.rightHospitalState, '');
  setProperty(properties.rightHospital, '');
  setProperty(properties.rightUploadedLogo, '');
  setProperty(properties.rightFont, '');
  setProperty(properties.rightTextColour, '');
  setProperty(properties.rightReturningLogo, '');
}

  function syncAccordionHeight() {
    if (!panel || panel.hidden || panel.style.maxHeight === '0px') return;
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  function openPanel() {
    if (!panel || !trigger) return;

    panel.hidden = false;
    panel.style.maxHeight = panel.scrollHeight + 'px';
    trigger.classList.add('is-open');
    trigger.textContent = '− Hide Embroidery Options';
  }

  function closePanel() {
    if (!panel || !trigger) return;

    panel.style.maxHeight = panel.scrollHeight + 'px';

    requestAnimationFrame(() => {
      panel.style.maxHeight = '0px';
      trigger.classList.remove('is-open');
      trigger.textContent = '+ Add Custom Embroidery';
    });
  }

  function getSelectValue(selector) {
    const el = customiser.querySelector(selector);
    return el ? el.value : '';
  }

  function getLogoSource(side) {
    const source = getSelectValue(`[data-logo-source="${side}"]`);

    if (source === 'hospital') return 'Hospital';
    if (source === 'upload') return 'Upload';
    if (source === 'returning') return 'Returning Customer Logo';

    return '';
  }

  function getStateLabel(value) {
    const labels = {
      nsw: 'NSW',
      vic: 'VIC',
      qld: 'QLD',
      wa: 'WA',
      sa: 'SA',
      tas: 'TAS',
      act: 'ACT',
      nt: 'NT'
    };

    return labels[value] || '';
  }

function getPreviewTextColour(value) {
    if (value === 'White') return '#fff';
    if (value === 'Black') return '#111';

    return '#111';
    }

function getPreviewFont(value) {
  if (value === 'Lucida Calligraphy') return '"Lucida Calligraphy", cursive';

  return 'Mavenpro-variablefont-wght, sans-serif';
}

function setProperty(field, value) {
  if (!field) return;

  field.value = value || '';

  if (!value || value === 'No' || value === '0' || value === '$0') {
    field.disabled = true;
  } else {
    field.disabled = false;
  }
}

function setFieldEnabled(field, enabled) {
  if (!field) return;

  field.disabled = !enabled;

  if (!enabled) {
    field.value = '';
  }
}

function hasUsableEmbroideryInfo(side, type) {
  if (!type) return false;

  const label = side === 'left' ? 'Left' : 'Right';

  if (type === 'text' || type === 'both') {
    const line1 = customiser.querySelector(`input[name="properties[${label} Text Line 1]"]`);
    const line2 = customiser.querySelector(`input[name="properties[${label} Text Line 2]"]`);

    const hasTextLine1 = line1 && line1.value.trim();
    const hasTextLine2 = line2 && line2.value.trim();

    if (hasTextLine1 || hasTextLine2) return true;
  }

  if (type === 'logo' || type === 'both') {
    const logoSource = getLogoSource(side);

    if (logoSource === 'Hospital') {
      const hospital = getSelectValue(`[data-hospital-select="${side}"]`);
      if (hospital) return true;
    }

    if (logoSource === 'Upload') {
      const uploadedLogo = side === 'left'
        ? properties.leftUploadedLogo
        : properties.rightUploadedLogo;

      if (uploadedLogo && uploadedLogo.value) return true;
    }

    if (logoSource === 'Returning Customer Logo') {
      const returningLogo = getSelectValue(`[data-returning-input="${side}"]`);
      if (returningLogo && returningLogo.trim()) return true;
    }
  }

  return false;
}

function updatePreview() {
  ['left', 'right'].forEach((side) => {
    const label = side === 'left' ? 'Left' : 'Right';
    const line1Input = customiser.querySelector(`input[name="properties[${label} Text Line 1]"]`);
    const line2Input = customiser.querySelector(`input[name="properties[${label} Text Line 2]"]`);
    const previewLine1 = customiser.querySelector(`[data-preview-line-1="${side}"]`);
    const previewLine2 = customiser.querySelector(`[data-preview-line-2="${side}"]`);
    const textColour = getSelectValue(`[data-colour-select="${side}"]`);
    const previewColour = getPreviewTextColour(textColour);
    const selectedFont = getSelectValue(`[data-font-select="${side}"]`);
    const previewFont = getPreviewFont(selectedFont);
    const previewSide = customiser.querySelector(`[data-preview-side="${side}"]`);
    const sideType = getSelectValue(`[data-side-type="${side}"]`);
    const hasText = sideType === 'text' || sideType === 'both';

    if (previewSide) {
    previewSide.hidden = !sideType;
    }
if (previewLine1) {
  previewLine1.textContent = hasText
    ? (line1Input && line1Input.value ? line1Input.value : 'First Line')
    : '';
  previewLine1.style.color = previewColour;
  previewLine1.style.fontFamily = previewFont;
}

if (previewLine2) {
  previewLine2.textContent = hasText
    ? (line2Input && line2Input.value ? line2Input.value : 'Second Line')
    : '';
  previewLine2.style.color = previewColour;
  previewLine2.style.fontFamily = previewFont;
}

    const previewLogo = customiser.querySelector(`[data-preview-logo="${side}"]`);
    const logoSource = getLogoSource(side);

    if (previewSide) {
    previewSide.classList.remove('has-logo');
    }

const uploadedLogo =
  side === 'left'
    ? properties.leftUploadedLogo
    : properties.rightUploadedLogo;

if (previewLogo) {
  previewLogo.classList.remove('is-visible');
  previewLogo.style.backgroundImage = '';
  previewLogo.textContent = '';

if (logoSource === 'Upload' && uploadedLogo && uploadedLogo.value) {
  previewLogo.style.backgroundImage = `url("${uploadedLogo.value}")`;
  previewLogo.classList.add('is-visible');
  if (previewSide) previewSide.classList.add('has-logo');
}

if (logoSource === 'Hospital') {
  const hospitalLogo = getSelectedHospitalLogo(side);

  if (hospitalLogo) {
    previewLogo.style.backgroundImage = `url("${hospitalLogo}")`;
  } else {
    previewLogo.style.backgroundImage = 'url("https://cdn.shopify.com/s/files/1/0390/6463/3388/files/placeholder-logo.png?v=1781944383")';
  }

  previewLogo.classList.add('is-visible');
  if (previewSide) previewSide.classList.add('has-logo');
}
}
  });
}

  function updateProperties(activeSides, totalPrice) {
    const leftType = getSelectValue('[data-side-type="left"]');
    const rightType = getSelectValue('[data-side-type="right"]');
    const leftFont = getSelectValue('[data-font-select="left"]');
    const rightFont = getSelectValue('[data-font-select="right"]');

    const leftTextLine1 = customiser.querySelector('input[name="properties[Left Text Line 1]"]');
    const leftTextLine2 = customiser.querySelector('input[name="properties[Left Text Line 2]"]');
    const rightTextLine1 = customiser.querySelector('input[name="properties[Right Text Line 1]"]');
    const rightTextLine2 = customiser.querySelector('input[name="properties[Right Text Line 2]"]');

    const leftHasText = leftType === 'text' || leftType === 'both';
    const rightHasText = rightType === 'text' || rightType === 'both';

    setFieldEnabled(leftTextLine1, leftHasText);
    setFieldEnabled(leftTextLine2, leftHasText);
    setFieldEnabled(rightTextLine1, rightHasText);
    setFieldEnabled(rightTextLine2, rightHasText);

    const leftTextColour = getSelectValue('[data-colour-select="left"]');
    const rightTextColour = getSelectValue('[data-colour-select="right"]');
    const leftLogoSource = (leftType === 'logo' || leftType === 'both')
      ? getLogoSource('left')
      : '';

    const rightLogoSource = (rightType === 'logo' || rightType === 'both')
      ? getLogoSource('right')
      : '';

    const leftState = getSelectValue('[data-state-select="left"]');
    const rightState = getSelectValue('[data-state-select="right"]');
    const leftHospital = getSelectValue('[data-hospital-select="left"]');
    const rightHospital = getSelectValue('[data-hospital-select="right"]');
    const leftReturningLogo = getSelectValue('[data-returning-input="left"]');
    const rightReturningLogo = getSelectValue('[data-returning-input="right"]');

const hasValidLeftEmbroidery = hasUsableEmbroideryInfo('left', leftType);
const hasValidRightEmbroidery = hasUsableEmbroideryInfo('right', rightType);
const hasValidEmbroidery = hasValidLeftEmbroidery || hasValidRightEmbroidery;

const cleanLeftType = hasValidLeftEmbroidery ? leftType : '';
const cleanRightType = hasValidRightEmbroidery ? rightType : '';
const cleanLeftLogoSource = hasValidLeftEmbroidery ? leftLogoSource : '';
const cleanRightLogoSource = hasValidRightEmbroidery ? rightLogoSource : '';

setProperty(properties.enabled, hasValidEmbroidery ? 'Yes' : 'No');

setProperty(
  properties.leftReturningLogo,
  cleanLeftLogoSource === 'Returning Customer Logo' ? leftReturningLogo : ''
);

setProperty(
  properties.rightReturningLogo,
  cleanRightLogoSource === 'Returning Customer Logo' ? rightReturningLogo : ''
);

setProperty(properties.leftType, cleanLeftType);
setProperty(properties.leftLogoSource, cleanLeftLogoSource);
setProperty(properties.leftHospitalState, cleanLeftLogoSource === 'Hospital' ? getStateLabel(leftState) : '');
setProperty(properties.leftHospital, cleanLeftLogoSource === 'Hospital' ? leftHospital : '');

setProperty(properties.rightType, cleanRightType);
setProperty(properties.rightLogoSource, cleanRightLogoSource);
setProperty(properties.rightHospitalState, cleanRightLogoSource === 'Hospital' ? getStateLabel(rightState) : '');
setProperty(properties.rightHospital, cleanRightLogoSource === 'Hospital' ? rightHospital : '');

setProperty(properties.leftFont, cleanLeftType === 'text' || cleanLeftType === 'both' ? leftFont : '');
setProperty(properties.rightFont, cleanRightType === 'text' || cleanRightType === 'both' ? rightFont : '');
setProperty(properties.leftTextColour, cleanLeftType === 'text' || cleanLeftType === 'both' ? leftTextColour : '');
setProperty(properties.rightTextColour, cleanRightType === 'text' || cleanRightType === 'both' ? rightTextColour : '');
setProperty(properties.sides, String(activeSides));
setProperty(properties.total, `$${totalPrice}`);
  }

function getEmbroideryPrice(type) {
  if (type === 'text') return 10;
  if (type === 'logo') return 15;
  if (type === 'both') return 15;

  return 0;
}

function updatePrice() {
  let activeSides = 0;
  let totalPrice = 0;

  sideTypes.forEach((select) => {
    if (isLeftOnlyProduct && select.dataset.sideType === 'right') return;

    const side = select.dataset.sideType;
    const type = select.value;

    if (hasUsableEmbroideryInfo(side, type)) {
      activeSides++;
      totalPrice += getEmbroideryPrice(type);
    }
  });

  if (total) {
    total.textContent = `$${totalPrice}`;
  }

  updateProperties(activeSides, totalPrice);
  updatePreview();
  syncAccordionHeight();
}

  function updateSide(side, value) {
    const sidePanel = customiser.querySelector(`[data-side-panel="${side}"]`);
    const logoSection = customiser.querySelector(`[data-logo-section="${side}"]`);
    const textSection = customiser.querySelector(`[data-text-section="${side}"]`);
    const textOptions = customiser.querySelector(`[data-text-options="${side}"]`);

    if (!sidePanel || !logoSection || !textSection) return;

    sidePanel.hidden = !value;
    logoSection.hidden = !(value === 'logo' || value === 'both');
    textSection.hidden = !(value === 'text' || value === 'both');

    if (textOptions) {
    textOptions.hidden = !(value === 'text' || value === 'both');
    }

    updatePrice();
  }

  function populateHospitals(side, stateValue) {
    const hospitalSelect = customiser.querySelector(`[data-hospital-select="${side}"]`);
    if (!hospitalSelect) return;

    hospitalSelect.innerHTML = '<option value="">Select Hospital</option>';

    const stateHospitals = hospitals[stateValue] || [];

    stateHospitals.forEach((hospital) => {
    const option = document.createElement('option');
    option.value = hospital.name;
    option.textContent = hospital.name;
    option.dataset.logo = hospital.logo;
    hospitalSelect.appendChild(option);
    });
  }

    function getSelectedHospitalLogo(side) {
    const hospitalSelect = customiser.querySelector(`[data-hospital-select="${side}"]`);
    if (!hospitalSelect) return '';

    const selectedOption = hospitalSelect.options[hospitalSelect.selectedIndex];
    return selectedOption ? selectedOption.dataset.logo || '' : '';
    }

  function updateLogoSource(side, source) {
    const hospitalFields = customiser.querySelector(`[data-hospital-fields="${side}"]`);
    const uploadFields = customiser.querySelector(`[data-upload-section="${side}"]`);
    const returningFields = customiser.querySelector(`[data-returning-section="${side}"]`);

    if (hospitalFields) {
      hospitalFields.hidden = source !== 'hospital';
    }

    if (uploadFields) {
      uploadFields.hidden = source !== 'upload';
    }

    if (returningFields) {
    returningFields.hidden = source !== 'returning';
    }

    updatePrice();
    syncAccordionHeight();
  }

  if (trigger && panel) {
    trigger.addEventListener('click', () => {
      if (panel.hidden || panel.style.maxHeight === '0px') {
        openPanel();
      } else {
        closePanel();
      }
    });

    panel.addEventListener('transitionend', () => {
      if (panel.style.maxHeight === '0px') {
        panel.hidden = true;
      } else {
        panel.style.maxHeight = 'none';
      }
    });
  }

  sideTypes.forEach((select) => {
    select.addEventListener('change', () => {
      updateSide(select.dataset.sideType, select.value);
    });

    updateSide(select.dataset.sideType, select.value);
  });

  customiser.querySelectorAll('[data-logo-source]').forEach((select) => {
    select.addEventListener('change', () => {
      updateLogoSource(select.dataset.logoSource, select.value);
    });

    updateLogoSource(select.dataset.logoSource, select.value);
  });

  customiser.querySelectorAll('[data-state-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const side = select.dataset.stateSelect;
      populateHospitals(side, select.value);
      updatePrice();
    });
  });

function updateCharacterCounter(field) {
  const counterKey = field.dataset.characterCounterInput;
  if (!counterKey) return;

  const counter = customiser.querySelector(`[data-character-counter="${counterKey}"]`);
  if (!counter) return;

  counter.textContent = `${field.value.length}/${embroideryTextLimit}`;

  counter.classList.toggle(
    'is-full',
    field.value.length >= embroideryTextLimit
  );
}

customiser.querySelectorAll('[data-embroidery-text-input]').forEach((field) => {
  field.addEventListener('input', () => {
    if (field.value.length > embroideryTextLimit) {
      field.value = field.value.slice(0, embroideryTextLimit);
    }

    updateCharacterCounter(field);
  });

  updateCharacterCounter(field);
});

  customiser.querySelectorAll('[data-hospital-select], [data-font-select], [data-colour-select], input[type="text"]').forEach((field) => {
    field.addEventListener('change', updatePrice);
    field.addEventListener('input', updatePrice);
  });

customiser.querySelectorAll('[data-upload-button]').forEach((button) => {
  button.addEventListener('click', () => {
    const side = button.dataset.uploadButton;
    const status = customiser.querySelector(`[data-upload-status="${side}"]`);
    const property =
      side === 'left'
        ? properties.leftUploadedLogo
        : properties.rightUploadedLogo;

    if (!window.cloudinary) {
      if (status) status.textContent = 'Upload tool is still loading. Please try again.';
      return;
    }

    const widget = window.cloudinary.createUploadWidget(
{
  cloudName: 'doiuep1ef',
  uploadPreset: 'Scrublab Embroidery',
  folder: 'scrublab-embroidery',
  sources: ['local'],
  multiple: false,
  clientAllowedFormats: ['jpg', 'jpeg', 'png', 'webp'],
  maxFileSize: 10000000,
},
      (error, result) => {
        if (error) {
          if (status) status.textContent = 'Upload failed. Please try again.';
          return;
        }

        if (result && result.event === 'success') {
          const uploadedUrl = result.info.secure_url;

          setProperty(property, uploadedUrl);

          if (status) {
            status.innerHTML = `<a href="${uploadedUrl}" target="_blank" rel="noopener">Logo uploaded</a>`;
          }

          updatePrice();
          syncAccordionHeight();
        }
      }
    );

    button.disabled = true;
    button.textContent = 'Opening upload...';
    if (status) {
    status.textContent = 'Opening upload window...';
    }

    widget.open();

    setTimeout(() => {
    button.disabled = false;
    button.textContent = property && property.value ? 'Replace Logo' : 'Upload Logo';
}, 3000);

  });
});

  enforceLeftOnlyProduct();
  updatePrice();
  }

  window.ScrubLabCustomiser = window.ScrubLabCustomiser || {};

  window.ScrubLabCustomiser.init = initialiseCustomiser;

  function initialiseExistingCustomisers() {
    document.querySelectorAll('#scrublab-customiser').forEach((customiser) => {
      initialiseCustomiser(customiser);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseExistingCustomisers);
  } else {
    initialiseExistingCustomisers();
  }
})();